
import {get_token} from "@/router";
import { client_domain } from "@/main.js";

export default {
  computed: {

    filtered_business() {
        return this.showAll ? this.business_profiles : this.business_profiles.slice(0, this.visibleCount);
      }
  },

  mounted() {

    this.token_exists = get_token();
    this.fetchCompanyProfile()
    if(client_domain.includes('tdm') || client_domain.includes('chamber')|| client_domain.includes('cbo') || client_domain.includes('engagenet')){
      this.visible_domain = true;

    }
  },
  data() {
    return ({
    business_profiles:[],
    token_exists: false,
    visibleCount: 4,
    visible_domain:false,
    showAll: false, 


    });
  },
  methods: {
    getToken() {
        return get_token();
    },

    fetchCompanyProfile() {
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_company_profile/`,
            type: "GET",
            headers: {
                Authorization: `Token ${get_token()}`,
                "Content-Type": "application/json",
            },
            success: (response) => {
                if (response.status === "success") {
                 this.business_profiles=response.data
                }
            },
            error: (xhr, status, error) => {
                console.error("Error fetching company profile:", error);
         
            }
        });
      },
      view_profile(profile){
        const base = profile.base_profile.id;
        const type = profile.base_profile.profile_type;
        window.location = `/profile?base=${base}&type=${type}`;
      }
  },
};